import React, { useState,useEffect } from 'react';
import axios from 'axios'
import CommonVars from '../Component/CommonVars';
import {
    Flex,
    Box,
    Image,
    chakra
  } from '@chakra-ui/react';
  


function HomeScreen(){
     const [products, setProducts] = useState('')
     

     useEffect(() =>{
        getProducts()
     },[])


     
     const getProducts = async() => {
            axios.get(`${CommonVars.API_URL}/products`)
            .then((res) =>{
                const productsData = res.data;
                console.log(res.data);
                setProducts(productsData);
            }).catch((err) =>{
                console.log(err)
            })
        };

        const aProducts = [];

        for(var i = 0; i < products.length; i++)
        {
            aProducts.push(
              <chakra.a key={products[i].productid} href={`/products/${products[i].productid}`}
              >
                        <Box
                        rounded={'20'}
                        bg={'gray.100'}
                        mb={'20px'}
                        shadow={'xl'}
                            p={10}
                            // width={"40%"}
                        >
                            <Image 
                                src={products[i].image}
                                boxSize={"280px"}
                                // mx={"auto"}
                            />
                            <Box marginTop={'10px'} fontWeight={'semibold'}>
                                {products[i].name}
                            </Box>
                            <Box fontWeight={'semibold'}>
                                ${products[i].price}  
                            </Box>
                        </Box>
              </chakra.a>
                
             
                
            )
        }



        return(
            <Box
            bg={'gray.100'}
            width="100wh"
            height="full"
           >
                <Box   p={50}>
                    <Flex direction={"row"} flexWrap={"wrap"} justifyContent={"space-around"}>
                        {aProducts}
                    </Flex>
                </Box>
            </Box>
            
        )
    
}

export default HomeScreen;